'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// import 'draft-js/dist/Draft.css'
// eslint-disable-next-line import/no-unresolved

// import { save } from 'redux/modules/saveUserData';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _reactDom = require('react-dom');

var _draftJs = require('draft-js');

var _templateData = require('redux/modules/templateData');

var templateData = _interopRequireWildcard(_templateData);

var _semanticUiReact = require('semantic-ui-react');

require('./TextAnalysis.css');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BOLD_THRESHOLD_LOWER = 0.1;
var BOLD_THRESHOLD_UPPER = 0.32;

var TextAnalysis = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    text_analysis_data: state.templateData.text_analysis_data,
    info_block: state.templateData.info_block,
    highlighted_action_verb: state.templateData.highlighted_action_verb
  };
}, {
  highlightActionVerb: templateData.highlightActionVerb
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(TextAnalysis, _Component);

  function TextAnalysis(props) {
    (0, _classCallCheck3.default)(this, TextAnalysis);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TextAnalysis.__proto__ || (0, _getPrototypeOf2.default)(TextAnalysis)).call(this, props));

    _this.state = {
      analysisTextVisible: false,
      multiple_verbs_found: false,
      action_verb: false,
      verbLemma: false,
      verb_tense_correct: true,
      present_experience: false
    };

    _this.handleIconClick = function (value) {

      if (value) {
        // const verbPosition = this.props.blockProps.dependency_list.indexOf('ROOT');


        var verbPosition = _this.props.blockProps.pos_list.indexOf('VERB');

        if (verbPosition >= 0) {

          if (verbPosition === 0) {
            if (_this.props.blockProps.date_to === 'Present') {
              _this.setState({ present_experience: true });
            } else {
              _this.setState({ present_experience: false });
              if (_this.props.blockProps.tag_list[verbPosition] === 'VBD' || _this.props.blockProps.tag_list[verbPosition] === 'VBN') {
                _this.setState({ verb_tense_correct: true });
              } else {
                _this.setState({ verb_tense_correct: false });
              }
            }
          }

          var actionVerb = _this.props.blockProps.word_list[verbPosition];
          var verbLemma = _this.props.blockProps.lemma_list[verbPosition];
          var text_analysis_data = _this.props.text_analysis_data;


          _this.setState({ action_verb: actionVerb, verbLemma: verbLemma });

          //calculating all text
          var verb_count = 0;

          for (var key_1 in text_analysis_data) {
            if (verb_count >= 2) {
              break;
            }
            if (text_analysis_data.hasOwnProperty(key_1)) {
              for (var key_2 in text_analysis_data[key_1]) {
                if (verb_count >= 2) {
                  break;
                }
                if (text_analysis_data[key_1].hasOwnProperty(key_2)) {
                  if (text_analysis_data[key_1][key_2].hasOwnProperty('lemma')) {
                    if (text_analysis_data[key_1][key_2]['lemma'].indexOf(verbLemma) >= 0) {
                      var index_of_lemma = text_analysis_data[key_1][key_2]['lemma'].indexOf(verbLemma);
                      if (text_analysis_data[key_1][key_2]['pos'][index_of_lemma] == 'VERB') verb_count += 1;
                    }
                  }
                }
              }
            }
          }

          if (verb_count >= 2) {
            _this.setState({ multiple_verbs_found: true });
          } else {
            _this.setState({ multiple_verbs_found: false });
          }
          _this.props.highlightActionVerb(verbLemma);
        }
      } else {
        _this.props.highlightActionVerb(false);
      }

      _this.setState({ analysisTextVisible: value });
    };

    return _this;
  }

  (0, _createClass3.default)(TextAnalysis, [{
    key: 'componentDidMount',
    value: function componentDidMount() {

      // const verbPosition = this.props.blockProps.dependency_list.indexOf('ROOT');
      var verbPosition = this.props.blockProps.pos_list.indexOf('VERB');

      if (verbPosition >= 0) {

        if (verbPosition === 0) {
          if (this.props.blockProps.date_to === 'Present') {
            this.setState({ present_experience: true });
          } else {
            this.setState({ present_experience: false });
            if (this.props.blockProps.tag_list[verbPosition] !== 'VBN') {
              this.setState({ verb_tense_correct: false });
            } else {
              this.setState({ verb_tense_correct: true });
            }
          }
        }

        var actionVerb = this.props.blockProps.word_list[verbPosition];
        var verbLemma = this.props.blockProps.lemma_list[0];

        var text_analysis_data = this.props.text_analysis_data;


        this.setState({ action_verb: actionVerb, verbLemma: verbLemma });

        //calculating all text
        var verb_count = 0;

        for (var key_1 in text_analysis_data) {
          if (verb_count >= 2) {
            break;
          }
          if (text_analysis_data.hasOwnProperty(key_1)) {
            for (var key_2 in text_analysis_data[key_1]) {
              if (verb_count >= 2) {
                break;
              }
              if (text_analysis_data[key_1].hasOwnProperty(key_2)) {
                if (text_analysis_data[key_1][key_2].hasOwnProperty('lemma')) {
                  if (verbLemma == text_analysis_data[key_1][key_2]['lemma'][0]) {
                    verb_count += 1;
                  }
                }
              }
            }
          }
        }

        if (verb_count >= 2) {
          this.setState({ multiple_verbs_found: true });
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {

      if (!nextProps.highlighted_action_verb && this.state.analysisTextVisible) {
        this.setState({ analysisTextVisible: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          block = _props.block,
          contentState = _props.contentState;
      var _props$blockProps = this.props.blockProps,
          dependency_list = _props$blockProps.dependency_list,
          pos_list = _props$blockProps.pos_list,
          word_list = _props$blockProps.word_list,
          shape_list = _props$blockProps.shape_list,
          tag_list = _props$blockProps.tag_list;
      var _state = this.state,
          analysisTextVisible = _state.analysisTextVisible,
          multiple_verbs_found = _state.multiple_verbs_found,
          action_verb = _state.action_verb,
          verb_tense_correct = _state.verb_tense_correct,
          present_experience = _state.present_experience;


      var hasBoldStyle = block.getCharacterList().filter(function (item) {
        return item.hasStyle('BOLD') === true;
      });

      var bulletText = block.getText();
      var sentence_length = block.getText().length;
      var actual_bold_ratio;
      if (hasBoldStyle.size > 0 && sentence_length > 0) {
        actual_bold_ratio = hasBoldStyle.size / sentence_length;
      } else {
        actual_bold_ratio = false;
      }

      var has_bold_style = hasBoldStyle.size > 0 ? true : false;
      var number_found_nummod = dependency_list.indexOf('nummod') > 0;
      var contains_semi_colon = bulletText.indexOf(';') > 0;
      var ends_with_period = bulletText.trim().substr(bulletText.trim().length - 1) === '.';

      var number_found_pobj = pos_list.some(function (item, index) {
        if (item == 'NUM' && (dependency_list[index] == 'pobj' || dependency_list[index] == 'dobj')) {
          return true;
        }
      });

      var number_found = number_found_nummod || number_found_pobj;
      var sentence_length_ok = sentence_length > 70 && sentence_length < 140;
      var starts_with_power_verb = pos_list[0] == 'VERB';
      var actual_bold_ratio_ok;
      if (actual_bold_ratio) {
        actual_bold_ratio_ok = actual_bold_ratio >= BOLD_THRESHOLD_LOWER && actual_bold_ratio < BOLD_THRESHOLD_UPPER;
      } else {
        actual_bold_ratio_ok = false;
      }

      var pointStyle = void 0;
      var point_score = (number_found + sentence_length_ok + !multiple_verbs_found + starts_with_power_verb + has_bold_style) / 5;

      if (point_score < 0.4) {
        pointStyle = { style: 'negative', icon: 'remove circle', color: 'red' };
      } else if (point_score >= 0.4 && point_score < 0.7) {
        pointStyle = { style: 'neutral', icon: 'exclamation circle', color: 'yellow' };
      } else {
        pointStyle = { style: 'positive', icon: 'check circle', color: 'green' };
      }

      return _react2.default.createElement(
        'span',
        { className: 'textAnalysis', style: { paddingLeft: '0px' } },
        analysisTextVisible && _react2.default.createElement(
          'div',
          { className: 'textAnalysis-pointer', contentEditable: false },
          _react2.default.createElement(_semanticUiReact.Icon, { color: 'blue', name: 'long arrow left' })
        ),
        _react2.default.createElement(_draftJs.EditorBlock, (0, _extends3.default)({ editable: true }, this.props)),
        _react2.default.createElement(
          'div',
          { className: 'textAnalysisWrapper textAnalysisWrapper-' + pointStyle.style, contentEditable: false },
          _react2.default.createElement(_semanticUiReact.Icon, { name: pointStyle.icon, style: { cursor: 'pointer' }, onClick: function onClick(e) {
              // event.stopPropagation();
              _this2.handleIconClick(true);
            } }),
          analysisTextVisible && _react2.default.createElement(AnalysisTextBox, {
            number_found: number_found,
            handleIconClick: function handleIconClick(value) {
              return _this2.handleIconClick(value);
            },
            sentence_length_ok: sentence_length_ok,
            multiple_verbs_found: multiple_verbs_found,
            action_verb: action_verb,
            starts_with_power_verb: starts_with_power_verb,
            has_bold_style: has_bold_style,
            verb_tense_correct: verb_tense_correct,
            present_experience: present_experience,
            sentence_length: sentence_length,
            actual_bold_ratio: actual_bold_ratio,
            actual_bold_ratio_ok: actual_bold_ratio_ok,
            contains_semi_colon: contains_semi_colon,
            ends_with_period: ends_with_period,
            word_list: word_list,
            shape_list: shape_list,
            pos_list: pos_list,
            tag_list: tag_list
          })
        )
      );
    }
  }]);
  return TextAnalysis;
}(_react.Component)) || _class);
exports.default = TextAnalysis;

var AnalysisTextBox = function (_Component2) {
  (0, _inherits3.default)(AnalysisTextBox, _Component2);

  function AnalysisTextBox(props) {
    (0, _classCallCheck3.default)(this, AnalysisTextBox);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (AnalysisTextBox.__proto__ || (0, _getPrototypeOf2.default)(AnalysisTextBox)).call(this, props));

    _this3.hasSomeParentTheClass = function (element, classname) {
      if (element.className) {
        if (element.className.split(' ').indexOf(classname) >= 0) return true;
      }
      return element.parentNode && _this3.hasSomeParentTheClass(element.parentNode, classname);
    };

    _this3.closeTextAnalysis = function (e) {

      // if(!findDOMNode(this).contains(e.target) && !this.hasSomeParentTheClass(e.target,'textAnalysis')
      //  && !this.hasSomeParentTheClass(e.target,'wordOptionsWrapper')) {
      //   this.props.handleIconClick(false);
      // }
      if (_this3.hasSomeParentTheClass(e.target, 'textAnalysisWrapper') || _this3.hasSomeParentTheClass(e.target, 'sectionAnalysis') || _this3.hasSomeParentTheClass(e.target, 'subSectionAnalysis') || _this3.hasSomeParentTheClass(e.target, 'resumeAnalysisBox')) {
        _this3.props.handleIconClick(false);
      }
    };

    return _this3;
  }

  (0, _createClass3.default)(AnalysisTextBox, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.addEventListener('click', this.closeTextAnalysis, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.closeTextAnalysis, false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          number_found = _props2.number_found,
          sentence_length_ok = _props2.sentence_length_ok,
          multiple_verbs_found = _props2.multiple_verbs_found,
          action_verb = _props2.action_verb,
          starts_with_power_verb = _props2.starts_with_power_verb,
          has_bold_style = _props2.has_bold_style,
          verb_tense_correct = _props2.verb_tense_correct,
          present_experience = _props2.present_experience,
          sentence_length = _props2.sentence_length,
          actual_bold_ratio = _props2.actual_bold_ratio,
          actual_bold_ratio_ok = _props2.actual_bold_ratio_ok,
          contains_semi_colon = _props2.contains_semi_colon,
          ends_with_period = _props2.ends_with_period,
          shape_list = _props2.shape_list,
          word_list = _props2.word_list,
          pos_list = _props2.pos_list,
          tag_list = _props2.tag_list;

      //checking if the bullettext has an abbreviation

      var has_acronym = false;
      has_acronym = shape_list.some(function (item, index) {
        if (/^x\.x/.test(item)) {
          return true;
        }
      });

      // const proper_noun_list = word_list.filter((item, index) => {
      //   console.log(tag_list[index], item)
      //   return pos_list[index] == 'PROPN'
      // })
      //
      // console.log(proper_noun_list);

      var positiveStyle = { color: 'green', icon: 'checkmark' };
      var negativeStyle = { color: 'red', icon: 'close' };

      var numberPointStyle = number_found ? positiveStyle : negativeStyle;
      var lengthPointStyle = sentence_length_ok ? positiveStyle : negativeStyle;
      var multipleVerbsPointStyle = !multiple_verbs_found ? positiveStyle : negativeStyle;
      var startsWithVerbPointStyle = starts_with_power_verb ? positiveStyle : negativeStyle;
      var hasBoldPointStyle = has_bold_style ? positiveStyle : negativeStyle;
      var boldRatioPointStyle = actual_bold_ratio_ok ? positiveStyle : negativeStyle;
      var semiColonPointStyle = !contains_semi_colon ? positiveStyle : negativeStyle;
      var endsWithPeriodPointStyle = !ends_with_period ? positiveStyle : negativeStyle;
      var acronymPointStyle = !has_acronym ? positiveStyle : negativeStyle;

      var verbTensePointStyle;
      var verbTensePointText;
      if (!present_experience) {
        if (verb_tense_correct) {
          verbTensePointStyle = positiveStyle;
          verbTensePointText = 'Great job! You have used the starting verb of this sentence in the right tense.';
        } else {
          verbTensePointStyle = negativeStyle;
          verbTensePointText = 'Looks like this a past work experience. You haven\'t used the starting verb in the correct tense. Such errors can confuse recruiters. ';
        }
      }

      var action_verb_text = action_verb ? '\'' + action_verb + '\'' : 'this verb';

      var numberPointText = number_found ? 'Great Job! You have quantified your bullet.' : 'Looks like you haven\'t quantified your bullet. Adding numbers can increase your chances of getting noticed by a recruiter.';

      var lengthPointText = sentence_length_ok ? 'Great Job! The length of your bullet is appropriate as per current resume standards.' : sentence_length < 70 ? 'Your bullet is too short. We recommend that you add more information to this bullet. Think around the impact that you can exhibit.' : 'Your bullet is too long. We recommend that you either split it into two parts or create a sub-bullet to show information clearly.';

      var multipleVerbsPointText = !multiple_verbs_found ? 'Good Job! You have used ' + action_verb_text + ' only once in your resume.' : 'You have used ' + action_verb_text + ' multiple times in your resume! Try to use a different verb to increase the impact of your resume.';

      var startsWithVerbPointText = starts_with_power_verb ? 'Good Job! You have used an action verb to start your bullet.' : 'Start every bullet with a power verb. This will get you noticed by recruiters and make a lasting impression.';

      var hasBoldPointPointText = has_bold_style ? actual_bold_ratio_ok ? 'Good Job! You have highlighted the ideal amount of text in this bullet. Use this to bring out important facts and numbers in your resume.' : actual_bold_ratio < BOLD_THRESHOLD_LOWER ? 'Although you have highlighted some part of the bullet, we encourage you to highlight more to draw the the recruiter\'s attention. Focus on numbers and achievements.' : 'Looks like you\'ve bolded a large part of this sentence. Try to restrict bolding to only the important parts.' : 'Looks like you have not highlighted anything in this bullet. That might be okay, but we strongly recommend that you BOLD important facts and numbers to catch the recruiter\'s attention.';

      var semiColonPointText = 'Looks like you have used a semi colon in this bullet. We recommend that you either reframe the bullet or break it down.';

      var endsWithPeriodPointText = 'Your bullet should not end with a period.';

      var acronymPointText = 'Looks like you\'ve used an acronym in your bullet. Ensure that you expand it once in the resume to give more clarity to the recruiter.';

      return _react2.default.createElement(
        _semanticUiReact.Card,
        { className: 'textanalysis-card textanalysis-card-active' },
        _react2.default.createElement(
          _semanticUiReact.Card.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Card.Header,
            null,
            _react2.default.createElement(
              'div',
              null,
              ' Bullet Feedback'
            ),
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', style: { cursor: 'pointer' }, color: 'black', onClick: function onClick(e) {
                return _this4.props.handleIconClick(false);
              } })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Card.Content,
          { style: { padding: '5px', maxHeight: '300px', overflow: 'auto', scrollBehavior: 'auto' } },
          _react2.default.createElement(
            _semanticUiReact.Feed,
            { className: 'textAnalysis-feed', size: 'small', style: { fontSize: '10px' } },
            _react2.default.createElement(
              _semanticUiReact.Feed.Event,
              null,
              _react2.default.createElement(_semanticUiReact.Feed.Label, { icon: numberPointStyle.icon, style: { color: numberPointStyle.color } }),
              _react2.default.createElement(
                _semanticUiReact.Feed.Content,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Feed.Summary,
                  null,
                  numberPointText
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Feed.Event,
              null,
              _react2.default.createElement(_semanticUiReact.Feed.Label, { icon: lengthPointStyle.icon, style: { color: lengthPointStyle.color } }),
              _react2.default.createElement(
                _semanticUiReact.Feed.Content,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Feed.Summary,
                  null,
                  lengthPointText
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Feed.Event,
              null,
              _react2.default.createElement(_semanticUiReact.Feed.Label, { icon: multipleVerbsPointStyle.icon, style: { color: multipleVerbsPointStyle.color } }),
              _react2.default.createElement(
                _semanticUiReact.Feed.Content,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Feed.Summary,
                  null,
                  multipleVerbsPointText
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Feed.Event,
              null,
              _react2.default.createElement(_semanticUiReact.Feed.Label, { icon: startsWithVerbPointStyle.icon, style: { color: startsWithVerbPointStyle.color } }),
              _react2.default.createElement(
                _semanticUiReact.Feed.Content,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Feed.Summary,
                  null,
                  startsWithVerbPointText
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Feed.Event,
              null,
              _react2.default.createElement(_semanticUiReact.Feed.Label, { icon: hasBoldPointStyle.icon, style: { color: hasBoldPointStyle.color } }),
              _react2.default.createElement(
                _semanticUiReact.Feed.Content,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Feed.Summary,
                  null,
                  hasBoldPointPointText
                )
              )
            ),
            starts_with_power_verb && !present_experience && _react2.default.createElement(
              _semanticUiReact.Feed.Event,
              null,
              _react2.default.createElement(_semanticUiReact.Feed.Label, { icon: verbTensePointStyle.icon, style: { color: verbTensePointStyle.color } }),
              _react2.default.createElement(
                _semanticUiReact.Feed.Content,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Feed.Summary,
                  null,
                  verbTensePointText
                )
              )
            ),
            ends_with_period && _react2.default.createElement(
              _semanticUiReact.Feed.Event,
              null,
              _react2.default.createElement(_semanticUiReact.Feed.Label, { icon: endsWithPeriodPointStyle.icon, style: { color: endsWithPeriodPointStyle.color } }),
              _react2.default.createElement(
                _semanticUiReact.Feed.Content,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Feed.Summary,
                  null,
                  endsWithPeriodPointText
                )
              )
            ),
            contains_semi_colon && _react2.default.createElement(
              _semanticUiReact.Feed.Event,
              null,
              _react2.default.createElement(_semanticUiReact.Feed.Label, { icon: semiColonPointStyle.icon, style: { color: semiColonPointStyle.color } }),
              _react2.default.createElement(
                _semanticUiReact.Feed.Content,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Feed.Summary,
                  null,
                  semiColonPointText
                )
              )
            ),
            has_acronym && _react2.default.createElement(
              _semanticUiReact.Feed.Event,
              null,
              _react2.default.createElement(_semanticUiReact.Feed.Label, { icon: acronymPointStyle.icon, style: { color: acronymPointStyle.color } }),
              _react2.default.createElement(
                _semanticUiReact.Feed.Content,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Feed.Summary,
                  null,
                  acronymPointText
                )
              )
            )
          )
        )
      );
    }
  }]);
  return AnalysisTextBox;
}(_react.Component);

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TextAnalysis/TextAnalysis.js
// module id = 1751
// module chunks = 0